import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import CustomToolTip from '../_tooltip';
import { competencyLegend } from '../_base';
import { useSelector } from 'react-redux';
import { e4Format, e4Formats } from 'helpers/dates';

const Chart = ({ data, item }) => {
    const values = data[0];
    const [legend1, setLegend1] = React.useState('Metric');

    const competencies = useSelector(state => state.dashboard.competencies);
    const { user } = useSelector(state => state.user);
    const ratingRange = user.companySettings?.display?.ratingRange || 5;

    React.useEffect(() => {
        if (item?.data) {
            const parsed = JSON.parse(item.data);
            setLegend1(competencyLegend(parsed.competency1, competencies));
        }
    }, [values, item, competencies]);

    return (
        <ResponsiveBar
            data={data[0].data.map(d => ({ id: d.x, value: d.y }))}
            margin={{ top: 10, right: 60, bottom: 50, left: 60 }}
            valueFormat={x => `${user?.currencySymbol}${(x / 1000).toFixed()}k`}
            colors={{ scheme: 'nivo' }}
            padding={0.2}
            borderRadius={2}
            borderWidth={1}
            borderColor={{ from: 'color', modifiers: [['darker', '0.5']] }}
            minValue={0}
            maxValue={ratingRange}
            axisTop={null}
            axisLeft={null}
            axisBottom={null}
            axisRight={{
                tickValues: [0, 1, 2, 3, 4, 5],
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: `${legend1}`,
                legendPosition: 'middle',
                legendOffset: 40,
            }}
            enableGridY
            enableLabel={false}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            legends={[]}
            tooltip={point => (
                <CustomToolTip
                    point={point}
                    legend={legend1}
                    x="id"
                    y="value"
                    xFormat={x => e4Format(x, e4Formats.monthShort)}
                />
            )}
        />
    );
};

export default Chart;
